import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/fitpiggy.webp';
import screenshot_target from '../../../images/letterfunnel/leanschieving.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Lean Schieving"
      firstname="Lean"
      companyname="Fit Piggy"
      competition="Barebells en Body & Fit"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/leanschieving.js